module.exports = __webpack_public_path__ + "img/stack-stack.1fe45e98.png";